var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-navbar',{attrs:{"logo-url":_vm.logo,"user":_vm.user.loggedInUser,"profile-data":_vm.profileData}})}
var staticRenderFns = []

export { render, staticRenderFns }